import React, { Suspense, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Float, Sparkles } from "@react-three/drei";

function Rotator({ children, speed = 0.2 }) {
  const ref = useRef();
  useFrame((_state, delta) => {
    if (!ref.current) return;
    ref.current.rotation.y += speed * delta;
    ref.current.rotation.x += (speed / 3) * delta;
  });
  return <group ref={ref}>{children}</group>;
}

function Scene() {
  return (
    <>
      <ambientLight intensity={0.6} />
      <directionalLight position={[4, 6, 5]} intensity={0.8} color={"#ffffff"} />
      <directionalLight position={[-4, -2, -5]} intensity={0.4} color={"#835F21"} />

      <Sparkles count={80} scale={[6, 6, 6]} size={2} speed={0.3} color={"#FFF1D0"} />

      <Float speed={1.2} rotationIntensity={0.5} floatIntensity={1.2}>
        <Rotator speed={0.15}>
          <mesh position={[0, 0, 0]} castShadow receiveShadow>
            <torusKnotGeometry args={[1.1, 0.26, 160, 12, 2, 3]} />
            <meshStandardMaterial
              color={"#835F21"}
              metalness={0.75}
              roughness={0.3}
              envMapIntensity={1}
            />
          </mesh>
        </Rotator>
      </Float>

      <Float speed={0.8} rotationIntensity={0.2} floatIntensity={0.6}>
        <mesh position={[0, 0, -0.2]}>
          <torusGeometry args={[1.9, 0.05, 32, 180]} />
          <meshStandardMaterial color={"#B8904A"} metalness={0.9} roughness={0.15} />
        </mesh>
      </Float>
    </>
  );
}

export default function Hero3D() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-y-0 right-0 w-full sm:w-1/2 md:w-[55%] lg:w-[50%] z-[15]"
    >
      <Canvas
        dpr={[1, 2]}
        camera={{ position: [0, 0, 4.2], fov: 45 }}
        gl={{ antialias: true, alpha: true }}
      >
        <Suspense fallback={null}>
          <Scene />
        </Suspense>
      </Canvas>
    </div>
  );
}

